import React, { Fragment } from "react";
import { Route } from "react-router-dom";
import PicaCSVzDashboard from "../Clients/PicaC&SVz/PicaC&SVzDashboard";
import AppFooter from "../Layout/AppFooter/";
// Layout
import AppHeader from "../Layout/AppHeader/";
import AppSidebar from "../Layout/AppSidebar/";

const ClientsDashboards = ({ match }) => (
  <Fragment>
    <AppHeader />
    <div className="app-main">
      <AppSidebar />
      <div className="app-main__outer">
        <div className="app-main__inner">
          <Route
            path={`${match.url}`}
            component={PicaCSVzDashboard}
          />
        </div>
        <AppFooter />
      </div>
    </div>
  </Fragment>
);

export default ClientsDashboards;



// WEBPACK FOOTER //
// ./src/Stations/ClientsDashboards.js